export const blockIconsAndroidDataUsageNew = (
	<span className='material-symbols-outlined'>data_usage</span>
);
